import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// let root= document.getElementById("root")

ReactDOM.render(<App />, document.getElementById('root'));
